import { composeIO } from 'react-compose-io'
import { modalBuscarOPSIO } from './ModalBuscarOPS.IO'
import { ModalBuscarOPSView } from './ModalBuscarOPS.View'

export const ModalBuscarOPS = composeIO(ModalBuscarOPSView, modalBuscarOPSIO)
